import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Checkbox } from "@nextui-org/react";
import Upload from "../Upload";
import upload_red from "../../assets/icons/upload_red.png";

const AudioUploadForm = ({ onSubmitForm = () => {} }) => {
  const { t } = useTranslation();
  const [isNoIncoming, setIsNoIncoming] = useState(false);
  const [isNoOutgoing, setIsNoOutgoing] = useState(false);
  return (
    <div className="p-12">
      <div className="flex gap-x-6 mb-8">
        <div className="w-full flex flex-col gap-y-4">
          <Upload labelClassname="incoming" />
          <Checkbox
            isSelected={isNoIncoming}
            onValueChange={setIsNoIncoming}
            classNames={{ label: "text-sm text-gray-400" }}
          >
            {t("No incoming")}
          </Checkbox>
        </div>
        <div className="w-full flex flex-col gap-y-4">
          <Upload
            labelClassname="outgoing"
            labelIcon={upload_red}
          />
          <Checkbox
            isSelected={isNoOutgoing}
            onValueChange={setIsNoOutgoing}
            classNames={{ label: "text-sm text-gray-400" }}
          >
            {t("No outgoing")}
          </Checkbox>
        </div>
      </div>
      <Button
        className="w-full h-12 uppercase"
        color="primary"
        onPress={onSubmitForm}
      >
        {t("Upload Files")}
      </Button>
    </div>
  );
};

export default AudioUploadForm;
